import { getFallbackLocale } from "utils/locale";

const kFormatter = (number) => {
  if (number > 999999) {
    return `${(number / 1000000).toLocaleString(getFallbackLocale(), {
      maximumFractionDigits: 2,
    })}M`;
  }
  if (number > 9999) {
    return `${(number / 1000).toLocaleString(getFallbackLocale(), {
      maximumFractionDigits: 0,
    })}k`;
  }

  return number;
};

export default kFormatter;
